import * as React from 'react';

import { PageLayout, type PageLayoutProps } from '@neo.tax/shared';
import { useSredPageLockStatus } from '@neo.tax/sred/hooks';

export const SredLockPageLayout: React.FC<
  Omit<PageLayoutProps, 'locked' | 'lockedReason'> & {
    forceUnlock?: boolean;
    disableIfOngoingSync?: boolean;
  }
> = ({ children, disableIfOngoingSync, forceUnlock, lockButtons, ...rest }) => {
  const { pageLockStatus } = useSredPageLockStatus({ disableIfOngoingSync });

  return (
    <PageLayout
      locked={forceUnlock ? false : pageLockStatus.locked}
      lockButtons={
        forceUnlock ? (
          []
        ) : (
          <>
            {pageLockStatus.lockButtons}
            {lockButtons}
          </>
        )
      }
      lockedReason={forceUnlock ? '' : pageLockStatus.lockedReason}
      {...rest}
    >
      {children}
    </PageLayout>
  );
};
